import React, { useRef } from "react";
import Slider from "react-slick";
import tw from "twin.macro";
import styled, { css } from "styled-components/macro";
import { ReactComponent as ArrowLeftIcon } from "images/arrow-left-3-icon.svg";
import { ReactComponent as ArrowRightIcon } from "images/arrow-right-3-icon.svg";
import "slick-carousel/slick/slick.css";


const StyledSliderContainer = styled.div`
  ${tw`text-white -m-16`}
`;

const TestimonialsSlider = styled(Slider)`
  ${tw`mx-auto md:mx-64 max-w-full`}
  .slick-slide {
    ${tw`p-16`}
  }
`;

const Testimonial = styled.div`
  ${tw`bg-white rounded-lg shadow-xl overflow-hidden`}
  transition: transform 0.3s ease;
`;

const TestimonialContent = styled.div`
  ${tw`p-4 sm:p-4 flex flex-col h-full`}
`;

const Quote = styled.blockquote`
  ${tw`font-medium text-gray-800 text-sm mb-3 flex-grow`}
`;

const Author = styled.div`
  ${tw`mt-2`}
`;

const AuthorName = styled.span`
  ${tw`block text-base font-semibold text-gray-900`}
`;

const AuthorPosition = styled.span`
  ${tw`block text-sm text-gray-600`}
`;


const isMobile = window.innerWidth <= 768;

const settings = {
  dots: false,
  infinite: true,
  speed: 700,
  slidesToShow: isMobile ? 1 : 1,
  slidesToScroll: 1,
  autoplay: true,
  responsive: [
    {
      breakpoint: 640,
      settings: {
        slidesToShow: 1,
      }
    }
  ]
};



const Testimonials = ({
  translations
}) => {
  const sliderRef = useRef(null);
  const testimonials = !isMobile ? translations.testimonialsData : translations.testimonialsData.slice(-5);

  return (
    <StyledSliderContainer>
      <TestimonialsSlider {...settings} arrows={false} ref={sliderRef}>
        {testimonials.map((testimonial, index) => (
          <Testimonial key={index}>
            <TestimonialContent>
              <Quote>{testimonial.quote}</Quote>
              <Author>
                <AuthorName>{testimonial.customerName}</AuthorName>
                <AuthorPosition>{testimonial.position || 'Community member'}</AuthorPosition>
              </Author>
            </TestimonialContent>
          </Testimonial>
        ))}
      </TestimonialsSlider>
    </StyledSliderContainer>
  );
};

export default Testimonials;